import React from 'react';
import { ConfigProvider, type ConfigProviderProps } from 'antd';
import en from 'antd/lib/locale/en_US';
import pl from 'antd/lib/locale/pl_PL';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';

import 'dayjs/locale/en';
import 'dayjs/locale/pl';

/**
 * ConfigProvider antd, którego `locale` (paginacja, DatePicker, puste stany) i locale dayjs podążają
 * za językiem i18n — przełączenie języka w trakcie sesji odświeża je bez przeładowania.
 */
export const LocalizedConfigProvider: React.FC<Omit<ConfigProviderProps, 'locale'>> = ({
  children,
  ...props
}) => {
  const { i18n } = useTranslation();
  const isPolish = i18n.language?.toLowerCase().startsWith('pl') ?? false;

  // Ustawiane synchronicznie (idempotentnie), bo dzieci formatują daty już w tym samym renderze.
  dayjs.locale(isPolish ? 'pl' : 'en');

  return (
    <ConfigProvider locale={isPolish ? pl : en} {...props}>
      {children}
    </ConfigProvider>
  );
};
